import angular from 'angular';
import CartMiniController from "./cartmini-controller";
import CartMiniService from "./cartmini-service";


let CartMini = angular
    .module('CartMini', [])
    .controller('CartMiniController', CartMiniController)
    .service('CartMiniService', CartMiniService);

export default CartMini;

